import { render, staticRenderFns } from "./Textname.vue?vue&type=template&id=7c4f21b5&scoped=true&"
import script from "./Textname.vue?vue&type=script&lang=js&"
export * from "./Textname.vue?vue&type=script&lang=js&"
import style0 from "./Textname.vue?vue&type=style&index=0&id=7c4f21b5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4f21b5",
  null
  
)

export default component.exports